import { HiOutlineLink } from "react-icons/hi";
import { Box } from "../../primitives";
import ErrorIconWithTooltip from "../ErrorIconWithTooltip/ErrorIconWithTooltip";

interface CardMarketCompatibleProps {
  isSelected?: boolean;
  cardmarketProductId?: number;
}

export const CardMarketCompatible = ({
  isSelected = false,
  cardmarketProductId = undefined,
}: CardMarketCompatibleProps) => {
  if (cardmarketProductId) {
    return (
      <div style={{ position: "absolute", top: 5, right: 5 }}>
        <button
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (cardmarketProductId) {
              window.open(
                `https://www.cardmarket.com/en/Magic/Products?idProduct=${cardmarketProductId}`,
                "_blank"
              );
            }
          }}
        >
          <HiOutlineLink size={26} color={isSelected ? "white" : "#166534"} />
        </button>
      </div>
    );
  }

  return (
    <div style={{ position: "absolute", top: 5, right: 5 }}>
      <Box>
        <ErrorIconWithTooltip message="This cards cannot be uploaded on cardmarket" />
      </Box>
    </div>
  );
};
